import { render } from "./pro-info.vue?vue&type=template&id=003ca4aa&scoped=true"
import script from "./pro-info.vue?vue&type=script&lang=js"
export * from "./pro-info.vue?vue&type=script&lang=js"

import "./pro-info.vue?vue&type=style&index=0&id=003ca4aa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-003ca4aa"

export default script